import classes from "./select.module.scss";
import { useCallback, useRef, useState } from "react";
import ArrowIcon from "./images/icons/dropdownIcon.svg?react";
import { useOnClickOutside } from "usehooks-ts";

export interface IItemList {
  label: string;
  value: string | null;
}

interface IProps {
  label?: string;
  value: string | null;
  list: IItemList[];
  onChange: (value: string | null) => void;
}

export const Select = ({ label, list, value, onChange }: IProps) => {
  const [isOpen, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const currentItem = list.find((item) => {
    return item.value === value;
  });

  const handleToggle = () => {
    setOpen(prev => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useOnClickOutside(ref as React.RefObject<HTMLDivElement>, handleClose);

  const handleChange = useCallback((item: IItemList) => {
    if (item.value === value) {
      return;
    }
    onChange(item.value);
  }, [onChange, value]);

  const options = list.map(item => {
    const classNames = [classes.dropdownItem];

    if (item.value === value) {
      classNames.push(classes.isActive);
    }

    return (
      <li
        className={classNames.join(" ")}
        key={item.value}
        onClick={() => handleChange(item)}
      >
        {item.label}
      </li>
    );
  });

  return (
    <div className={classes.wrapper} ref={ref}>
      { label && <label className={classes.label}>{ label }</label> }
      <div
        className={`${classes.select} ${isOpen ? classes.isOpen : ""}`}
        onClick={handleToggle}
      >
        <div className={classes.selected}>
          <span className={classes.selectedLabel}>{currentItem ? currentItem.label : ""}</span>
        </div>

        <ul className={classes.dropdown}>
          { options }
        </ul>

        <div className={classes.arrow}>
          <ArrowIcon />
        </div>
      </div>
    </div>
  );
};
